var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.classes},_vm.$listeners),[_vm._t("default"),(!!_vm.text)?_c('text-body-extra-small',{staticClass:"pc-navigation-tabs-secondary__tab-text",attrs:{"lineHeight":"multi"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }